angular.module('qkr').directive('vizLinechart', ($parse, $window) => ({

        restrict: 'EA',
        template: '<svg width=\'850\' height=\'400\'></svg>',
        link(scope, elem, attrs) {
            let margin = {top: 20, right: 20, bottom: 30, left: 50},
                width = 850 - margin.left - margin.right,
                height = 400 - margin.top - margin.bottom;

            const exp = $parse(attrs.chartData);

            let yAxisLabel = 'Test Label';
            if (attrs.yAxisLabel != null) {
                yAxisLabel = attrs.yAxisLabel;
            }

            let isXAxisDate = false;
            if (attrs.xAxisDate != null) {
                isXAxisDate = attrs.xAxisDate;
            }

            // Var parseDate = d3.time.format("%d-%b-%y");

            let dataToPlot = exp(scope);

            const pathClass = 'path';
            let x, y, xAxis, yAxis, line, svg;

            const d3 = $window.d3;

            scope.$watchCollection(exp, (newVal, oldVal) => {
                dataToPlot = newVal;

                dataToPlot.sort((a, b) => a.x > b.x);
                // If (isXAxisDate) {
                    angular.forEach(dataToPlot, (value, index) => {
                        const d = new Date(parseInt(value.x));
                        value.x = d;
                    });

                // }

                if (hasChartData()) {
                    drawLineChart();
                }
            });

            function setChartParameters() {
                x = d3.time.scale().range([0, width]);
                // X = d3.scale.linear().range([0, width]);

                y = d3.scale.linear()
                    .range([height, 0]);

                xAxis = d3.svg.axis()
                    .scale(x)
                    .orient('bottom');

                yAxis = d3.svg.axis()
                    .scale(y)
                    .orient('left');

                line = d3.svg.line()
                    .x((d) => x(d.x))
                    .y((d) => y(d.y));

                svg = d3.select('body svg')
//                Svg = d3.select("body").append("svg")
//                    .attr("width", width + margin.left + margin.right)
//                    .attr("height", height + margin.top + margin.bottom)
                    .append('g')
                    .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

                x.domain(d3.extent(dataToPlot, (d) => d.x));
                y.domain(d3.extent(dataToPlot, (d) => d.y));
            }

            function drawLineChart() {
                setChartParameters();

                svg.append('g')
                    .attr('class', 'x axis')
                    .attr('transform', 'translate(0,' + height + ')')
                    .call(xAxis);

                svg.append('g')
                    .attr('class', 'y axis')
                    .call(yAxis)
                    .append('text')
                    .attr('transform', 'rotate(-90)')
                    .attr('y', 6)
                    .attr('dy', '.71em')
                    .style('text-anchor', 'end')
                    .text(yAxisLabel);

                svg.append('path')
                    .datum(dataToPlot)
                    .attr('class', 'line')
                    .attr('d', line);
            }

            function hasChartData() {
                return dataToPlot != null && dataToPlot.length > 0;
            }
        }

    }));



// WEBPACK FOOTER //
// ./src/directives/data-viz/line-chart.js